import { AuthRepository } from '@/context/global/api/repository/auth';
import { AxiosInstance } from 'axios';

export const AuthAPI = (axios: AxiosInstance): AuthRepository => {
  return {
    GetOAuth() {
      return axios.get('/v7/service/admd/web/oauth?appTemplate=website');
    },
  };
};
